import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// `text-initials`, `text-meta` and `text-reading` are font sizes (tailwind.config.cjs); without this, tailwind-merge
// reads them as text colours and drops them, or the real colour, when both are passed.
const twMerge = extendTailwindMerge({ extend: { classGroups: { "font-size": [{ text: ["initials", "meta", "reading"] }] } } });

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
